import { useNavigate } from 'react-router-dom';
import CloudBand from '../components/common/CloudBand';
import styles from './NotFoundPage.module.css';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <main className={styles.page}>
      <CloudBand variant="cream" className={styles.cloudBand} />
      <p className={styles.heading} aria-label="404">404</p>
      <img
        src="/assets/mascot-404-searching.webp"
        alt="Characters searching for the missing page"
        className={styles.mascot}
      />
      <div className={styles.content}>
        <p className={styles.subtitle}>Hmmm... this page doesn't seem to exist.</p>
        <button
          type="button"
          onClick={() => navigate('/')}
          className={styles.button}
        >
          Take me back home
        </button>
      </div>
    </main>
  );
}
